import { IGetAllGestaoEpiUseCase } from "../../../presentation/useCases/read/get_all_gestao_epi_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";
import { GestaoEpi } from "../../models/gestao_epi";

/**
 * GetAllGestaoEpiUseCase
 */

export class GetAllGestaoEpiUseCase extends BasePaginatedUseCase<GestaoEpi> implements IGetAllGestaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {
    super();
  }

  async getAllGestaoEpi(
    nome: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const {
      items,
      totalItems,
      totalPages,
      currentPage,
      pageSize,
    } = await this.repository.getAllGestaoEpi(
      nome,
      page,
      rowsPerPage,
    );

    this._items = items;
    this._totalItems = totalItems;
    this._totalPages = totalPages;
    this._currentPage = currentPage;
    this._pageSize = pageSize;
  }
}
